import { mobileMinWidth, theme } from '~constants'
const { colors } = theme

export const webScreenStyle = {
  alignSelf: 'center',
  backgroundColor: colors.background,
  minWidth: mobileMinWidth,
  width: '100%',
} as const
